import { defineTokens } from '@chakra-ui/react'

export const shadows = defineTokens.shadows({
  card: { value: '0 4px 16px rgba(0, 0, 0, 0.3)' },
  'card-light': { value: '0 1px 3px rgba(0, 0, 0, 0.1)' },
  elevated: { value: '0 8px 32px rgba(0, 0, 0, 0.5)' },
  dropdown: { value: '0 4px 12px rgba(0, 0, 0, 0.4)' },
  'panel-dark': { value: '0 -4px 16px rgba(0, 0, 0, 0.5)' },
  'panel-light': { value: '0 -4px 24px rgba(0, 0, 0, 0.12)' },
})
